import ParameterErrors from '../errors/ParameterErrors';
import Vector2 from '../geometry/Vector2';
import Location from '../modelling/Location';
import UrlHelper from '../core/UrlHelper';
import PlotStatus from './PlotStatus';
import HouseTypes from './HouseTypes';
import RoomType from './RoomType';
import eventEnable from '../core/eventEnable';
import Handles from '../core/Handles';
import enableAcceptBindings from '../mvvm/enableAcceptBindings';
import exposeBinding from '../mvvm/exposeBinding';
const { throwNotProvided, throwNotOfType} = ParameterErrors;
export default class SiteJsonUnitBirdsEyeView{
	constructor(props){
		const {angle, markerPosition}=props;
		if(angle===undefined||angle===null)
			throwNotProvided('angle');
		
		if(typeof(angle)!=='number')
			throwNotOfType('angle', 'number');
		this._angle = angle;
		
		if(markerPosition===undefined || markerPosition===null)
			throwNotProvided('markerPosition');
		this._markerPosition = markerPosition;
	}
	get angle(){
	    return this._angle;
	}
	get markerPosition(){
		return this._markerPosition;
	}
	toJSON(){
		throw new Error('Not implemented');
	}
	static fromJSON(jObject){
		return new SiteJsonUnitBirdsEyeView({
			angle:jObject.angle, 
			markerPosition:jObject.markerPosition?Vector2.fromObj(jObject.markerPosition):null
		});
	}
	
}